module.exports = __webpack_public_path__ + "static/media/Icon-Record.2d360707.svg";